import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChildren } from "@angular/core";
import { Router } from '@angular/router';
import { BaseSiteService, GlobalMessageService, GlobalMessageType, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { filter, take } from 'rxjs/operators';
import { CustomProfileAndPreferencesService } from "src/app/custom-profile-and-preferences/custom-profile-and-preferences.service";
import { LoactionStripService } from "src/app/shared/modules/location-strip/loaction-strip.service";
import { BaseService } from "src/app/shared/services/base.service";
import { CommonUtils } from "src/app/shared/utils/common.utils";
import { NumberSix, NumberTen, NumberThree } from "src/app/shared/utils/constants/global.constants";
import * as config from '../../../app/shared/config/app.config';
import { CustomInfluenzaService } from "../custom-influenza.service";

@Component({
  selector: 'app-recurring-reservation',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './recurring-reservation.component.html',
  styleUrls: ['./recurring-reservation.component.scss'],
})
export class RecurringReservationComponent implements OnInit, AfterViewInit {
  userData: any;
  b2bUnitID: any;
  accntId;
  @ViewChildren('editContentSection') editList: any;
  searchText;
  subscriptions = new Subscription();
  confirmStatus: boolean = false;
  initialFlagValueForAll: boolean = false;
  iscontactMethodThere: boolean = false;
  arrForStore = [];
  successMsg: boolean = false;
  alternativeDataSet: boolean = false;
  fluContactId: any;
  countofEnrolledStatus: any = 0;
  cMethodVal: boolean = true;
  allEnrolled = false;
  emailErrorMsg2: boolean = false;
  emailErrorMsg: boolean = false;
  phoneErrorMsg: boolean = false;
  nameErrorMsg: boolean = false;
  faxErrorMsg: boolean = false;
  dataSetForEdit: any;
  locationName: any;
  addressDetails;
  editOn: boolean = false;
  arrLength: any;
  locationSelectorOn: boolean = false;
  ordersList: any;
  ordersListCopy: any;
  baseSiteId: any;
  locationSub: any;
  selectedUid: any;
  b2bSub: Subscription;
  resDetailsSub: any;
  saveResSub: any;
  userAccountDetailsSub: any;
  userAccountDetailsSub2: any;
  saveResSub2: any;
  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly rt: Router,
    private readonly baseService: BaseService,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly user: UserAccountFacade,
    private readonly globalMessage: GlobalMessageService,
    private baseSiteService: BaseSiteService,
    private readonly pfService: CustomProfileAndPreferencesService,
    private locService: LoactionStripService
  ) { }

  ngOnInit(): void {
    this.locationSub = this.locService.emitSelectedLocs.pipe(filter(locs => !!locs?.length), take(1)).subscribe(locsData => {
      this.selectedUid = locsData[0].accountNumber;
    });
    this.initializeOninit();
    //this.influenzaService.getReservationDetails(this.userData.uid);
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
  }

  initializeOninit() {
    this.b2bSub = this.baseService.get(config.GET_ACCOUNT_ID).subscribe((res) => {
      if (res) {
        this.b2bUnitID = res?.defaultB2BUnit?.uid;
        this.influenzaService.getReservationDetails(this.b2bUnitID);
        this.b2bSub?.unsubscribe();
      }
    });



    this.resDetailsSub = this.influenzaService.reservationDetails.subscribe((resp) => {
      if (resp) {
        this.ordersList = JSON.parse(JSON.stringify(resp.influenzaContactInfos));
        //this.ordersList = [];


        // if (!this.ordersList[0].hasOwnProperty("email")) {
        if (this.ordersList.length < 1) {
          this.alternativeDataSet = true;
          this.subscriptions.add(this.locService.emitSelectedLocs$.subscribe(res => {
            this.accntId = res.length ? res[0].accountNumber : JSON.parse(sessionStorage.getItem('defaultLocation'))[0]?.accountNumber;
            this.pfService.getReccuringReservation(this.accntId);
            this.getReccReservationData();
            this.cdr.detectChanges();
          }));


          this.ordersList.forEach(ele => {
            if (!ele.hasOwnProperty("fluContactId")) {
              var usrId = localStorage.getItem('userId')?.trim()?.replace(/['"]+/g, '');

              //this.pfService.getUserAccountDetailsDataFromDb(usrId, this.accntId);
              this.userAccountDetailsSub = this.pfService.userAccountDetails.subscribe((userData) => {
                if (userData) {
                  ele.fluContactId = ele.shippingAddresses.accountNumber + "_" + userData?.res?.customerSalesAreaData.salesOrg;
                  this.userAccountDetailsSub?.unsubscribe();
                }
              });


              ele.fullName = ele.locationName;
              // this.iscontactMethodThere = true;
              ele.iscontactMethodThere = true;
              ele.contactMethod = "INT";

            }
            else {
              ele.fullName = (ele?.firstName != undefined ? ele?.firstName : '') + ' ' + (ele?.lastName != undefined ? ele?.lastName : '');
              this.iscontactMethodThere = false;
              ele.iscontactMethodThere = false;
            }
          })
          this.ordersListCopy = JSON.parse(JSON.stringify(this.ordersList));
        }


        // this.ordersList.forEach(ele => {
        //   this.validateFaxNumber(ele.phoneNo, 'phone', ele.fluContactId);
        //   this.validateFaxNumber(ele.fax, 'fax', ele.fluContactId);
        // });
        else {
          this.alternativeDataSet = false;
          this.countofEnrolledStatus = this.ordersList.filter(
            (el) => el.enrollflag == true
          );
          this.countofEnrolledStatus = this.countofEnrolledStatus?.length ? this.countofEnrolledStatus?.length : 0;
          this.ordersList.forEach((ele) => {
            ele.addressID = ele?.fluContactId;
            //ele.contactMethod = "fax";

            if (!ele.hasOwnProperty("fluContactId")) {
              var usrId = localStorage.getItem('userId')?.trim()?.replace(/['"]+/g, '');

              //this.pfService.getUserAccountDetailsDataFromDb(usrId, this.accntId);
              this.userAccountDetailsSub2 = this.pfService.userAccountDetails.subscribe((userData) => {
                if (userData) {
                  ele.fluContactId = ele.shippingAddresses.accountNumber + "_" + userData?.res?.customerSalesAreaData.salesOrg;
                  this.userAccountDetailsSub2?.unsubscribe();
                }
              });


              ele.fullName = ele.locationName;
              // this.iscontactMethodThere = true;
              ele.iscontactMethodThere = true;

            }
            else {
              if (ele.hasOwnProperty("firstName")) {
                ele.fullName = (ele?.firstName != undefined ? ele?.firstName : '') + ' ' + (ele?.lastName != undefined ? ele?.lastName : '');
              }
              else {
                ele.fullName = ele.locationName;
              }

              this.iscontactMethodThere = false;
              ele.iscontactMethodThere = false;
            }

            ele.editModeOn = false;
            if (ele?.hasOwnProperty('disableFax')) {
              ele.showFax = ele?.disableFax;  //if disableFax false, then hide fax option
              // if fax is disabled, making the contact method as email,in case it was fax before.
              if (!ele.showFax) {
                ele.contactMethod = 'INT';
              }
            }
            else {
              ele.showFax = true; //by default fax(true) will be shown
            }
            if (ele.contactMethod == 'INT') {
              ele.contactEmail = true;
            } else {
              ele.contactEmail = false;
            }
          });

          this.ordersListCopy = JSON.parse(JSON.stringify(this.ordersList));
          this.arrLength = this.ordersList?.length ? this.ordersList?.length : 0;
          this.cdr.detectChanges();
        }
        this.resDetailsSub?.unsubscribe();
      }
    });
  }
  ngAfterViewInit() {
  }
  SaveAction() {
    var obj = {};
    if (!this.cMethodVal) {
      if (this.dataSetForEdit.fax == undefined || this.dataSetForEdit.fax == '') {
        this.faxErrorMsg = true;
        return false;
      }
      else {
        this.faxErrorMsg = false;
      }
    }
    else {
      if (this.dataSetForEdit.email == undefined || this.dataSetForEdit.email == '') {
        this.emailErrorMsg = true;
        return false;
      }
      else {
        this.emailErrorMsg = false;
      }
    }

    var FullNameVar = this.dataSetForEdit?.fullName;
    FullNameVar = FullNameVar.trimStart();
    var arr = FullNameVar.split(' ');
    obj = {
      enrollflag: false,
      influenzaContactInfos: [
        {
          contactMethod: this.cMethodVal ? 'INT' : 'fax',
          email: this.dataSetForEdit.email,
          // enrollflag: this.dataSetForEdit.enrollflag,
          // fax: this.dataSetForEdit.fax,
          enrollflag: this.dataSetForEdit.enrollflag ? true : false,
          fax: this.dataSetForEdit.fax != undefined ? this.dataSetForEdit.fax : '',
          firstName: arr[0],
          //fluContactId: !this.alternativeDataSet ? this.dataSetForEdit.fluContactId : this.fluContactId,
          fluContactId: this.dataSetForEdit.fluContactId,
          lastName: arr.length > 1 ? arr[1] : '',
          locationName: this.dataSetForEdit.locationName,
          phoneNo: this.dataSetForEdit.phoneNo,
          shippingAddresses: {
            accountNumber: this.dataSetForEdit.shippingAddresses.accountNumber,
            country: {
              isocode: this.dataSetForEdit.shippingAddresses.country.isocode,
            },
            id: this.dataSetForEdit.shippingAddresses.id,
            line1: this.dataSetForEdit.shippingAddresses.line1,
            postalCode: this.dataSetForEdit.shippingAddresses.postalCode,
            town: this.dataSetForEdit.shippingAddresses.town,
          },
        },
      ],
    };
    this.influenzaService.saveReservationDetails(this.b2bUnitID, obj);
    this.saveResSub = this.influenzaService.reservationDetailsSave.subscribe((res) => {
      if (res?.status == 'success') {
        this.initializeOninit();
        this.editOn = false;
        this.successMsg = true;

        this.globalMessage.add(
          'Reservation contact details updated successfully.',
          GlobalMessageType.MSG_TYPE_CONFIRMATION, 1000
        );
        //this.router.goByUrl('/recurringPage');
        //location.reload();
        this.saveResSub?.unsubscribe();
      }
    });
  }

  cMethodElection(method) {
    if (method == 'INT') {
      this.cMethodVal = true;
      this.faxErrorMsg = false;
    } else {
      this.cMethodVal = false;
      this.emailErrorMsg = false;
      this.emailErrorMsg2 = false;
    }
  }

  nameValidation(nameVal) {
    if (nameVal == '') {
      this.nameErrorMsg = true;
    } else {
      this.nameErrorMsg = false;
    }
  }

  SaveActionforAll() {
    var arrForTotalSet = [];
    //var arr = this.dataSetForEdit.fullName.split(" ");

    this.ordersList.forEach((el) => {
      var obj = {
        contactMethod: this.cMethodVal ? 'INT' : 'FAX',
        email: el.email,
        enrollflag: !this.initialFlagValueForAll ? false : el.enrollflag,
        fax: el.fax,
        firstName: el.firstName,
        fluContactId: el.fluContactId,
        lastName: el.lastName,
        locationName: el.locationName,
        phoneNo: el.phoneNo,
        shippingAddresses: {
          accountNumber: el.shippingAddresses.accountNumber,
          country: {
            isocode: el.shippingAddresses.country.isocode,
          },
          id: el.shippingAddresses.id,
          line1: el.shippingAddresses.line1,
          postalCode: el.shippingAddresses.postalCode,
          town: el.shippingAddresses.town,
        },
      };
      arrForTotalSet.push(obj);
    });
    if(arrForTotalSet.map(el => el.hasOwnProperty('email') || el.hasOwnProperty('fax')).every(el => !!el)){
      var objFinalStructure = {
        influenzaContactInfos: arrForTotalSet,
      };

      this.influenzaService.saveReservationDetails(
        this.b2bUnitID,
        objFinalStructure
      );
      this.saveResSub2 = this.influenzaService.reservationDetailsSave.subscribe((res) => {
        if (res.status == 'success') {
          location.reload();
          this.saveResSub2?.unsubscribe();
        }
      });
    } else {
      this.globalMessage.add('Please provide email or fax number to continue.',GlobalMessageType.MSG_TYPE_ERROR, 50000);
    }
  }
  applySettingAll() {
    this.locationSelectorOn = !this.locationSelectorOn;
    this.arrForStore = [];
    this.ordersList.forEach((e) => {
      e.editModeOn = false;
      if (this.locationSelectorOn) {
        e.thisEleChecked = true;
      } else {
        e.thisEleChecked = false;
      }
    });
  }
  callsaveAction() {
    this.confirmStatus = false;
    this.SaveActionforAll();
  }
  clickApplytoAll() {
    this.confirmStatus = true;
  }
  cancelPopUp() {
    this.confirmStatus = false;
  }

  sortColumn(event, fieldName, dataList, type): any {
    CommonUtils.onSortClick(event, fieldName, dataList, type); // Column Sorting
  }
  cancelAllLocation() {
    this.ordersList = JSON.parse(JSON.stringify(this.ordersListCopy));
    this.arrForStore = [];
    this.locationSelectorOn = false;
    this.editOn = false;
    this.allEnrolled = false;
    this.ordersList.forEach((el) => {
      el['thisEleChecked'] = false;
    });
  }
  changeEnrollFlag(id, flag) {
    if (id == 'All') {
      this.initialFlagValueForAll = true;
      this.ordersList.forEach((ele) => {
        ele.enrollflag = flag.target.checked;
      });
    } else {
      var obj = {};
      var objSet = {};
      this.ordersList.forEach((ele) => {
        if (ele.fluContactId == id) {
          ele.enrollflag = flag;

          // obj["email"] = ele.email;
          // obj["phoneNo"] = ele.phoneNo;
          // obj["fax"] = ele.fax;
          // obj["enrollflag"] = ele.enrollflag;
          // obj["firstName"] = ele.firstName;
          // obj["lastName"] = ele.firstName;
          // obj["contactMethod"] = ele.contactMethod;

          objSet = {
            influenzaContactInfos: [ele],
          };
        }
      });
      if (!this.editOn) {
        this.influenzaService.saveReservationDetails(this.b2bUnitID, objSet);
        this.influenzaService.reservationDetailsSave.subscribe((res) => {
          if (res.status == 200) {
          }
        });
      }


      this.countofEnrolledStatus = this.ordersList.filter(
        (el) => el.enrollflag == true
      );
      this.countofEnrolledStatus = this.countofEnrolledStatus?.length ? this.countofEnrolledStatus?.length : 0;
    }
  }
  validateFaxNumber(event, type, id) {
    // if (fxNmbr == '' || fxNmbr.length != 12) {
    //   this.faxNumberError = true;
    // }
    // else {
    //   this.faxNumberError = false;
    // }
    // this.POnameEdited = true;
    if (event == '' || event.length < 10) {
      if (type == 'phone') {
        this.phoneErrorMsg = true;
      }
      if (type == 'fax') {
        this.faxErrorMsg = true;
      }
    } else {
      if (type == 'phone') {
        this.phoneErrorMsg = false;
      }
      if (type == 'fax') {
        this.faxErrorMsg = false;
      }
      if (event === null) {
        return null;
      }
      let newVal = event.replace(/\D/g, '');
      if (newVal.length === 0) {
        newVal = '';
      } else if (newVal.length <= NumberThree) {
        newVal = newVal.replace(/^(\d{0,3})/, '$1');
      } else if (newVal.length <= NumberSix) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
      } else if (newVal.length <= NumberTen) {
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1-$2-$3');
      } else {
        newVal = newVal.substring(0, NumberTen);
        newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '$1-$2-$3');
      }
      if (newVal === '') {
        newVal = null;
      }
      //return newVal;
      this.ordersList.forEach((el) => {
        if (el.fluContactId == id) {
          if (type == 'phone') {
            el.phoneNo = newVal;
          } else {
            el.fax = newVal;
          }
        }
      });
    }
  }
  //in case recurring-reservation/view-all api- doesnt have email
  getReccReservationData(): void {

    var usrId = localStorage.getItem('userId')?.trim()?.replace(/['"]+/g, '');

    this.pfService.getUserAccountDetailsDataFromDb(usrId, this.selectedUid);
    this.userAccountDetailsSub2 = this.pfService.userAccountDetails.subscribe((userData) => {
      // this.ordersList[0].locationName = userData?.res?.locName;
      // //this.ordersList[0].fluContactId = userData?.res?.influenzaContactInfos[0].shippingAddresses.id;
      // this.ordersList[0].fluContactId = userData?.res?.uid + "_" + userData?.res?.customerSalesAreaData.salesOrg;
      // this.ordersList[0].fullName = userData?.res?.accountAddress.facilityName;
      // this.ordersList[0].contactMethod = 'INT';
      // this.ordersList[0].email = userData?.res?.customerSalesAreaData.email;
      // this.ordersList[0].contactEmail = true;
      // //added for fax disable rule
      // this.ordersList[0].showFax = true;

      if (userData != "") {
        // obj_toPush["locationName"] = userData?.res?.locName;
        // obj_toPush["fluContactId"] = userData?.res?.uid + "_" + userData?.res?.customerSalesAreaData.salesOrg;
        // obj_toPush["fullName"] = userData?.res?.accountAddress.facilityName;
        // obj_toPush["contactMethod"] = 'INT';
        // obj_toPush["email"] = userData?.res?.customerSalesAreaData.email;
        // obj_toPush["contactEmail"] = true;
        // //added for fax disable rule
        // obj_toPush["showFax"] = true;

        // var obj_payerAddress = {};
        // var obj_shppingAddressesCountry = {};
        // obj_payerAddress["line1"] = userData?.res?.payerAddress.line1;
        // obj_payerAddress["town"] = userData?.res?.payerAddress.town;
        // obj_payerAddress["postalCode"] = userData?.res?.payerAddress.postalCode;
        // obj_payerAddress["country"] = userData?.res?.payerAddress.country;
        // obj_toPush["shippingAddresses"] = userData?.res?.payerAddress;


        // this.ordersList = [];
        // this.ordersList.push(obj_toPush);
        this.ordersList = userData?.res?.influenzaContactInfos;
        this.ordersList.forEach(ele => {
          if (ele.hasOwnProperty("firstName")) {
            ele.fullName = (ele?.firstName != undefined ? ele?.firstName : '') + ' ' + (ele?.lastName != undefined ? ele?.lastName : '');
          }
          else {
            ele.fullName = ele.locationName;
          }
          if (!ele.hasOwnProperty("fluContactId")) {
            ele.fluContactId = ele?.shippingAddresses?.accountNumber + "_" + userData?.res?.customerSalesAreaData?.salesOrg;
          }
        })
        this.userAccountDetailsSub2?.unsubscribe();
      }

      // this.ordersList[0].locationName = userData?.res?.locName;
      // //this.ordersList[0].fluContactId = userData?.res?.influenzaContactInfos[0].shippingAddresses.id;
      // this.ordersList[0].fluContactId = userData?.res?.uid + "_" + userData?.res?.customerSalesAreaData.salesOrg;
      // this.ordersList[0].fullName = userData?.res?.accountAddress.facilityName;
      // this.ordersList[0].contactMethod = 'INT';
      // this.ordersList[0].email = userData?.res?.customerSalesAreaData.email;
      // this.ordersList[0].contactEmail = true;
      // //added for fax disable rule
      // this.ordersList[0].showFax = true;



      this.fluContactId = userData?.res?.uid + "_" + userData?.res?.customerSalesAreaData.salesOrg;

      // this.accountNumber = userData?.res?.accountAddress?.accountNumber;
      // this.shippingData = userData?.res?.shippingAddress;
      // this.reccReservationDetails = userData?.res;
      // this.prefillReservationData();
      this.cdr.detectChanges();
    })
  }



  editModeOn(id) {
    this.faxErrorMsg = false;
    this.emailErrorMsg = false;
    this.emailErrorMsg2 = false;
    if (id != undefined) {
      this.editOn = true;
      this.ordersList.forEach((ele) => {
        if (ele.fluContactId == id) {
          ele.editModeOn = true;
          this.dataSetForEdit = ele;
          this.locationName = ele.locationName;
          this.addressDetails =
            ele.shippingAddresses?.line1 +
            ',' +
            ele.shippingAddresses?.town +
            ', ' +
            ele.shippingAddresses?.country?.isocode +
            ', ' +
            ele?.shippingAddresses?.postalCode;
        } else {
          ele.editModeOn = false;
        }
      });
    }

  }
  toggle(popover) {

    if (popover?.isOpen()) {

      popover?.close();

    } else {

      popover?.open();

    }

  }
  cancelEditSection(id) {
    this.ordersList = JSON.parse(JSON.stringify(this.ordersListCopy));
    this.editOn = false;
    this.ordersList.forEach((el) => {
      if (el.fluContactId == id) {
        el.editModeOn = false;
      }
    });

    let obj = this.ordersListCopy.find((o) => o.addressID === id);
    let obj2 = this.ordersList.find((o) => o.addressID === id);

    obj2.phoneNo = obj.phoneNo;
    obj2.fax = obj.fax;
    obj2.email = obj.email;
    obj2.enrollflag = obj.enrollflag;

    // // this.ordersList.forEach(element => {
    // //   if (element.shippingAddresses.id == obj.addressID) {
    // //     element = obj;
    // //   }
    // // });
    // this.ordersListCopy.map(obj => this.ordersList.find(o => o.addressID === obj.addressID) || obj);
  }

  validateEmailmethod(vl) {
    if (vl == '') {
      this.emailErrorMsg2 = true;
    } else {
      this.emailErrorMsg2 = false;
      if (!this.validateEmail(vl)) {
        this.emailErrorMsg = true;
      } else {
        this.emailErrorMsg = false;
      }
    }
  }

  // validateEmail(emailID) {
  //   var atpos = emailID.indexOf("@");
  //   var dotpos = emailID.lastIndexOf(".");
  //   if (atpos < 1 || (dotpos - atpos < 2)) {

  //     return false;
  //   }
  //   else {
  //     return true;
  //   }

  // }

  validateEmail(emailID) {
    const emailRegx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
    //if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,15})+$/.test(emailID)) {
    if (emailRegx.test(emailID)) {
      return true;
    }
    //alert("You have entered an invalid email address!")
    return false;
  }

  selectRadioFrRw(id, e) {
    if (e.target.checked) {
      if (!this.arrForStore.includes(id)) {
        this.arrForStore.push(id);
      }
    } else {
      this.arrForStore = this.arrForStore.filter(function (item) {
        return item !== id;
      });
      this.ordersList.forEach((e) => {
        if (e.fluContactId == id) {
          e.thisEleChecked = false;
        }
      });
    }
    this.arrForStore.forEach((el) => {
      this.ordersList.forEach((ele) => {
        if (el == ele.fluContactId) {
          ele['thisEleChecked'] = true;
        }
      });
    });
    if (this.arrForStore?.length == this.arrLength) {
      this.locationSelectorOn = true;
    } else {
      this.locationSelectorOn = false;
    }
  }
  searchResult(event) {
    const self = this;
    if (event == '') {
      this.ordersList = JSON.parse(JSON.stringify(this.ordersListCopy));
    } else {
      const result = self.ordersList.filter((res) => {
        return (
          res?.locationName?.toLowerCase().includes(event.toLowerCase()) ||
          res?.firstName?.toLowerCase().includes(event.toLowerCase()) ||
          res?.lastName?.toLowerCase().includes(event.toLowerCase()) ||
          res.shippingAddresses?.country?.isocode
            .toLowerCase()
            .includes(event.toLowerCase()) ||
          res.shippingAddresses?.town
            ?.toLowerCase()
            .includes(event.toLowerCase()) ||
          res.shippingAddresses?.line1
            ?.toLowerCase()
            .includes(event.toLowerCase()) ||
          res.shippingAddresses?.postalCode
            ?.toLowerCase()
            .includes(event.toLowerCase())
        );
      });

      this.ordersList = result;
    }
  }

  backToDashBoard() {
    this.router.goByUrl('influenza/dashboard');
  }

  ngOnDestroy() {
    this.subscriptions?.unsubscribe();
    this.locationSub?.unsubscribe();
    this.b2bSub?.unsubscribe();
    this.resDetailsSub?.unsubscribe();
    this.saveResSub?.unsubscribe();
    this.userAccountDetailsSub?.unsubscribe();
    this.userAccountDetailsSub2?.unsubscribe();
    this.saveResSub2?.unsubscribe();
    this.userAccountDetailsSub2?.unsubscribe();
  }
}